__turbopack_context__.v({
  "actionButton": "EditUserFormBase-module__yk2TNW__actionButton",
  "divider": "EditUserFormBase-module__yk2TNW__divider",
});
